import { SET_VIEW } from '../actions/types';
import initialState from '../initialState';
import { get, set } from 'global/lib/lodash';

export default function filter(state = initialState.view, action) {
  switch (action.type) {
    case SET_VIEW:
      if (!state.lang) {
        set(state, 'lang', get(initialState, 'view.lang', {}));
      }

      return {
        ...state,
        ...(action.view || {}),
      };
    default:
      return state;
  }
}
